"use client";

import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AddressMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const hours = [{
    day: "Wednesday",
    time: "08:00 — 17:00",
    isToday: true
  }, {
    day: "Thursday",
    time: "08:00 — 17:00",
    isToday: false
  }, {
    day: "Friday",
    time: "08:00 — 16:00",
    isToday: false
  }, {
    day: "Saturday",
    time: "Closed",
    isToday: false
  }, {
    day: "Sunday",
    time: "Closed",
    isToday: false
  }];
  return <section data-section-id="1839" id="address-map" className="relative overflow-hidden bg-background py-32 md:py-44 text-foreground">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute -left-32 top-1/4 h-[640px] w-[640px] opacity-[0.06]">
        <svg viewBox="0 0 600 600" className="h-full w-full">
          <path fill="hsl(183, 100%, 32%)" d="M300,80 C420,80 520,180 520,300 C520,420 420,520 300,520 C200,520 120,460 100,360 C80,260 140,160 240,110 C260,98 280,80 300,80 Z" />
        </svg>
      </div>

      <div ref={ref} className={`relative mx-auto max-w-[1360px] px-8 transition-all duration-700 ease-out md:px-16 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          {}
          <div className="order-2 flex flex-col lg:order-1 lg:col-span-5">
            {}
            

            {}
            <div className="mt-6 flex items-center">
              <div className="h-px flex-1 bg-border" />
              <div className="ml-2 h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
            </div>

            {}
            <h1 className="font-default mt-10 text-[clamp(2.5rem,5.5vw,4.5rem)] font-bold leading-[1.02] tracking-tighter text-foreground">
              Precision{" "}
              <span className="font-default font-bold text-secondary-foreground">
                Engineering
              </span>
              , at your doorstep
            </h1>

            {}
            <div className="mt-16 space-y-10">
              {}
              <div>
                
                <address className="font-default mt-4 text-[clamp(1.0625rem,1.25vw,1.1875rem)] not-italic leading-[1.6] text-foreground">
                  Wilge rd., Golfpark
                  <br />
                  Gauteng
                  <br />
                  South Africa, 1961
                </address>
              </div>

              <div className="flex items-center">
                <div className="h-px flex-1 bg-border" />
                <div className="ml-2 h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
              </div>

              {}
              <div>
                
                <p className="font-default mt-4 text-base leading-[1.65] text-foreground">
                  Nationwide Support — Specialized Siemens CNC Integration
                </p>
              </div>

              <div className="flex items-center">
                <div className="h-px flex-1 bg-border" />
                <div className="ml-2 h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
              </div>

              {}
              <div>
                
                
              </div>

              
            </div>

            {}
            <div className="mt-10 space-y-5">
              <Link to="mailto:charles@imcncdesigns.co.za" className="group flex items-center gap-4 text-foreground">
                <Mail className="h-4 w-4 text-secondary-foreground" strokeWidth={1.5} />
                <span className="font-default text-base">
                  charles@imcncdesigns.co.za
                </span>
                <span className="ml-1 flex flex-1 items-center transition-all duration-0 group-hover:ml-3">
                  <span className="h-px w-12 bg-border transition-all duration-0 group-hover:w-20 group-hover:bg-secondary-foreground" />
                  <span className="ml-1 h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
                </span>
                <span className="font-default text-base">→</span>
              </Link>

              <Link to="tel:0825538657" className="group flex items-center gap-4 text-foreground">
                <Phone className="h-4 w-4 text-secondary-foreground" strokeWidth={1.5} />
                <span className="font-default text-base">
                  +27 82 553 8657
                </span>
                <span className="ml-1 flex flex-1 items-center transition-all duration-0 group-hover:ml-3">
                  <span className="h-px w-12 bg-border transition-all duration-0 group-hover:w-20 group-hover:bg-secondary-foreground" />
                  <span className="ml-1 h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
                </span>
                <span className="font-default text-base">→</span>
              </Link>
            </div>

            {}
            <div className="mt-12">
              
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 lg:col-span-7">
            {}
            <div className="mb-5 flex items-center justify-between">
              
              <div className="flex items-center gap-2 font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-secondary-foreground">
                <span className="relative inline-flex h-1.5 w-1.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-md bg-secondary-foreground opacity-60" />
                  <span className="relative inline-flex h-1.5 w-1.5 rounded-md bg-secondary-foreground" />
                </span>
                
              </div>
            </div>

            <div className="relative">
              {}
              <span aria-hidden="true" className="absolute -left-2 -top-2 z-10 font-mono text-base text-secondary-foreground">
                +
              </span>
              <span aria-hidden="true" className="absolute -right-2 -top-2 z-10 font-mono text-base text-secondary-foreground">
                +
              </span>
              <span aria-hidden="true" className="absolute -bottom-2 -left-2 z-10 font-mono text-base text-secondary-foreground">
                +
              </span>
              <span aria-hidden="true" className="absolute -bottom-2 -right-2 z-10 font-mono text-base text-secondary-foreground">
                +
              </span>

              <AspectRatio ratio={4 / 5} className="overflow-hidden rounded-md border border-border bg-card">
                {}
                <div className="relative h-full w-full bg-card">
                  <svg viewBox="0 0 400 500" className="h-full w-full" preserveAspectRatio="xMidYMid slice">
                    {}
                    <rect width="400" height="500" fill="hsl(220, 10%, 95%)" />

                    {}
                    <path d="M 20 280 L 160 260 L 180 360 L 30 380 Z" fill="hsl(183, 100%, 32%)" opacity="0.1" />

                    {}
                    <g stroke="hsl(220, 48%, 12%)" strokeOpacity="0.1" strokeWidth="1" fill="none">
                      <path d="M 0 120 L 400 100" />
                      <path d="M 0 180 L 400 170" />
                      <path d="M 0 240 L 400 220" />
                      <path d="M 0 320 L 400 300" />
                      <path d="M 0 400 L 400 380" />
                      <path d="M 80 0 L 100 500" />
                      <path d="M 180 0 L 200 500" />
                      <path d="M 280 0 L 300 500" />
                    </g>

                    {}
                    <g stroke="hsl(183, 100%, 32%)" strokeOpacity="0.3" strokeWidth="1.5" fill="none">
                      <path d="M 0 200 L 400 190" />
                      <path d="M 220 0 L 240 500" />
                    </g>

                    {}
                    <g fill="hsl(220, 10%, 90%)" opacity="0.5">
                      <rect x="110" y="130" width="60" height="40" />
                      <rect x="210" y="130" width="60" height="40" />
                      <rect x="110" y="200" width="60" height="30" />
                      <rect x="210" y="200" width="60" height="30" />
                      <rect x="310" y="200" width="60" height="30" />
                      <rect x="110" y="330" width="60" height="40" />
                      <rect x="210" y="330" width="60" height="40" />
                      <rect x="310" y="330" width="60" height="40" />
                    </g>

                    {}
                    <text x="190" y="265" fill="hsl(220, 48%, 12%)" fontFamily="Roboto Mono, monospace" fontSize="8" letterSpacing="0.8" opacity="0.7">
                      WILGE RD
                    </text>
                    <text x="40" y="320" fill="hsl(220, 48%, 12%)" fontFamily="Roboto Mono, monospace" fontSize="8" letterSpacing="0.8" opacity="0.55">
                      GOLFPARK
                    </text>
                    <text x="250" y="115" fill="hsl(220, 48%, 12%)" fontFamily="Roboto Mono, monospace" fontSize="8" letterSpacing="0.8" opacity="0.7">
                      MEYERSDAL
                    </text>
                    <text x="20" y="195" fill="hsl(220, 48%, 12%)" fontFamily="Roboto Mono, monospace" fontSize="8" letterSpacing="0.8" opacity="0.7">
                      R59 HWY
                    </text>

                    {}
                    <g transform="translate(200, 250)">
                      {}
                      <circle r="12" fill="hsl(183, 100%, 32%)" opacity="0.15">
                        <animate attributeName="r" values="12;36;12" dur="2.2s" repeatCount="indefinite" />
                        <animate attributeName="opacity" values="0.4;0;0.4" dur="2.2s" repeatCount="indefinite" />
                      </circle>
                      <circle r="10" fill="hsl(183, 100%, 32%)" opacity="0.25">
                        <animate attributeName="r" values="10;24;10" dur="2.2s" repeatCount="indefinite" />
                        <animate attributeName="opacity" values="0.5;0;0.5" dur="2.2s" repeatCount="indefinite" />
                      </circle>
                      {}
                      <circle r="9" fill="hsl(220, 48%, 12%)" />
                      <circle r="3" fill="hsl(183, 100%, 32%)" />
                    </g>
                  </svg>
                </div>
              </AspectRatio>
            </div>

            <div className="mt-5 flex items-center justify-between font-mono text-[0.6875rem] uppercase tracking-[0.14em] text-muted-foreground"><span data-ast-id="f:/src/pages/ContactUs/sections/AddressMap.tsx|sig:7ev2ff" data-ast-start="10854" data-ast-end="10893">IMCNC Designs — Gauteng HQ - interntional service<br /><br /></span><span className="flex items-center gap-2" data-ast-id="f:/src/pages/ContactUs/sections/AddressMap.tsx|sig:emt9yo" data-ast-start="10908" data-ast-end="11113"><span className="h-1.5 w-1.5 rounded-md bg-secondary-foreground" data-ast-id="f:/src/pages/ContactUs/sections/AddressMap.tsx|sig:sda6rs" data-ast-start="11024" data-ast-end="11091"></span></span></div>
          </div>
        </div>
      </div>
    </section>;
}